window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

if (window.location.pathname.includes("tools/bundle-subscriptions/bundle/")) {
  const clean = () => {
    document.querySelectorAll("access-widget-ui").forEach((access) => access.remove());

    document.querySelectorAll("h4.bundle-product-card__title").forEach((title) => {
      console.log(title.innerText);
      if (title.innerText.endsWith(" - 1 JAR")) {
        title.innerText = title.innerText.replace(" - 1 JAR", "");
      }
      if (title.innerText.endsWith(" - 1 POUCH")) {
        title.innerText = title.innerText.replace(" - 1 POUCH", "");
      }
    });
  };
  const observer = new MutationObserver(() => {
    clean();
    setTimeout(() => {
      clean();
    }, 10);
  });

  let counter = 0;
  const callClean = () => {
    counter++;
    clean();
    if (counter < 100) {
      setTimeout(callClean, 100);
    }
  };

  const bodyElement = document.querySelector("body");

  observer.observe(bodyElement, { childList: true, subtree: true });
}
